<template>
  <div>
    <div class="navigation sub-level-navigation">
      <div class="row">
        <ul>
          <li>
            <router-link :to="{ name: 'about.personal' }">Personal details</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'about.super' }">Your current super</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'about.retirement' }">Retirement target</router-link>
          </li>
        </ul>

        <div class="sub-level-wrapper clearfix">
          <span class="location-progress" :style="{ display: $route.path === '/about/all' ? 'none' : '' }">{{ progress }} of 3</span>
          <router-link class="show-all-inputs" :to="{ name: 'about.all'}" v-if="$route.path !== '/about/all'">Show all inputs</router-link>
          <router-link class="show-all-inputs" :to="{ name: 'about.personal'}" v-else>Hide all inputs</router-link>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    progress() {
      if (this.$route.name === 'about.personal') {
        return 1;
      }

      if (this.$route.name === 'about.super') {
        return 2;
      }

      return 3;
    },
  },
};
</script>
